import { Check, CheckCheck } from "lucide-react";
import { MESSAGE_STATUS } from "./constants";
import { isSupportedMessageType } from "./messageTypes";

export const getInitials = (name = "") =>
  name
    .split(" ")
    .filter(Boolean)
    .map((part) => part[0])
    .join("")
    .toUpperCase();

export const getMessageStatusIcon = (status) => {
  switch (status) {
    case MESSAGE_STATUS.SENT:
      return <Check className="h-3.5 w-3.5 text-gray-400 dark:text-slate-500" />;
    case MESSAGE_STATUS.DELIVERED:
      return <CheckCheck className="h-3.5 w-3.5 text-gray-400 dark:text-slate-500" />;
    case MESSAGE_STATUS.READ:
      return <CheckCheck className="h-3.5 w-3.5 text-blue-500 dark:text-blue-400" />;
    default:
      return null;
  }
};

export const getFilteredConversations = (conversations, query) => {
  const normalizedQuery = query.trim().toLowerCase();
  if (!normalizedQuery) return conversations;

  return conversations.filter(
    (chat) =>
      chat.name.toLowerCase().includes(normalizedQuery) ||
      chat.phone.toLowerCase().includes(normalizedQuery)
  );
};

export const getCurrentTimeLabel = () =>
  new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });


export const isValidMessage = (message) => {
  if (!message || typeof message !== "object") return false;
  
  const { messageId, content, direction, status, createdAt } = message;
  
  if (!messageId || !content || !direction || !status || !createdAt) {
    return false;
  }

  if (!content.type) {
    return false;
  }

  return isSupportedMessageType(content.type);
};


export const getValidMessages = (messages = []) => {
  if (!Array.isArray(messages)) return [];
  return messages.filter(isValidMessage);
};

export const groupMessagesByDate = (messages = []) => {
  return messages.reduce((groups, message) => {
    const date = new Date(message.createdAt).toLocaleDateString();
    if (!groups[date]) {
      groups[date] = [];
    }
    groups[date].push(message);
    return groups;
  }, {});
};
